import React from "react";
import PropTypes from "prop-types";
import { Marker, Popup } from "react-leaflet";

import accessIconImg from "../../assets/images/access-icon.png";
import coalitionIconImg from "../../assets/images/coalition-icon.png";
import equipmentIconImg from "../../assets/images/equipment-icon.png";
import literacyIconImg from "../../assets/images/literacy-icon.png";

function SiteMarkers(props) {
  const { markers, icon } = props;
  // console.log(markers)

  return (
    <React.Fragment>
      {markers.map((site) => (
        <Marker
          position={[site.location.lat, site.location.lng]}
          key={
            site.site_name + site.location.lat + site.location.lng + site.metric
          }
          icon={icon}
        >
          <Popup>
            {site.type === "secondary" && site.metric === "access" ? (
              <img
                src={accessIconImg}
                style={{ height: 25, float: "left" }}
                alt="metric-icon"
              />
            ) : null}
            {site.type === "secondary" && site.metric === "coalition" ? (
              <img
                src={coalitionIconImg}
                style={{ height: 25, float: "left" }}
                alt="metric-icon"
              />
            ) : null}
            {site.type === "secondary" && site.metric === "equipment" ? (
              <img
                src={equipmentIconImg}
                style={{ height: 25, float: "left" }}
                alt="metric-icon"
              />
            ) : null}
            {site.type === "secondary" && site.metric === "literacy" ? (
              <img
                src={literacyIconImg}
                style={{ height: 25, float: "left" }}
                alt="metric-icon"
              />
            ) : null}
            <h3>{site.site_name}</h3>
            {site.description ? <p>{site.description}</p> : null}
            {site.link ? (
              <a href={site.link} target="_blank" rel="noreferrer">
                Learn More
              </a>
            ) : null}
          </Popup>
        </Marker>
      ))}
    </React.Fragment>
  );
}

SiteMarkers.propTypes = {
  markers: PropTypes.array,
  icon: PropTypes.object,
};
SiteMarkers.defaultProps = {
  markers: [],
  icon: null,
};

export default SiteMarkers;
